export default "__VITE_ASSET__120b2b97__"